import React, { Fragment, useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import StorefrontIcon from '@material-ui/icons/Storefront';
import StorefrontRoundedIcon from '@material-ui/icons/StorefrontRounded';
import Button from '@material-ui/core/Button';
import { PackageCard, SelectFieldOne, ButtonOne, TextInputFixedLabel, PhoneInputField, } from "master-react-lib";

import './OrderForm.css'

import { useSelector, useDispatch } from 'react-redux'
import { setRequesterInfo } from '../../features/counter/counterSlice'

const Delivery = (props) => {

    

    const rInfo = useSelector((state) => state.counter.requesterInfo);

    const [shippingDetails, setShippingDetails] = useState(rInfo);

    const dispatch = useDispatch();

    useEffect( ()=>{            

    }, []);
    
    
    const [phone, setPhone] = React.useState({
        country: "",
        number: "",
    });

    const cardFunction = (value) => {
        (value) && console.log("clicked");
    };

    const [errorFlag, setErrorFlag] = useState({
        firstName: false, 
        lastName: false, 
        streetAddress: false, 
        city: false, 
        postalCode: false, 
    });

    const continueClicked = async () => {
        let errorOccured = false ; 
        let errorFlagCopy = errorFlag ; 
        if( shippingDetails.shipppingFirstName.length < 1 ){
            errorFlagCopy.firstName = shippingDetails.shipppingFirstName.length < 1 ;
            
            errorOccured = true ; 
            
        }

        if( shippingDetails.shippingLastName.length < 1 ){
            errorFlagCopy.lastName = shippingDetails.shippingLastName.length < 1 ; 
            
            errorOccured = true ; 
             
        }else{
            errorFlagCopy.lastName = false ; 
        }

        if( shippingDetails.shippingCity.length < 1 ){
            errorFlagCopy.city = shippingDetails.shippingCity.length < 1 ;
            
            errorOccured = true ; 
            // return '' ; 
        }

        if( shippingDetails.shippingStreetAddress.length < 1 ){
            errorFlagCopy.streetAddress = shippingDetails.shippingStreetAddress.length < 1;
            
            errorOccured = true ; 
             
        }
        if( shippingDetails.shippingPostalCode.length < 1 ){
            errorFlagCopy.postalCode = shippingDetails.shippingPostalCode.length < 1; 
            
            errorOccured = true ; 
            
        }        

        if( !errorOccured ){
            props.setExpandPayment( true );
            props.deliveryCompleted( true );
        }else{
            setErrorFlag( {
                firstName: errorFlagCopy.firstName, 
                lastName: errorFlagCopy.lastName, 
                postalCode: errorFlagCopy.postalCode, 
                streetAddress: errorFlagCopy.streetAddress,
                city: errorFlagCopy.city,
            } );
            return ;
        }
        
    };

    const selectState = [
        { value:"AL", select: "Alabama"}, { value:"AK", select: "Alaska"}, { value:"AS", select: "American Samoa"}, { value:"AZ", select: "Arizona"}, { value:"AR", select: "Arkansas"}, { value:"CA", select: "California"}, { value:"CO", select: "Colorado"}, { value:"CT", select: "Connecticut"}, { value:"DE", select: "Delaware"}, { value:"DC", select: "District Of Columbia"}, { value:"FM", select: "Federated States Of Micronesia"}, { value:"FL", select: "Florida"}, { value:"GA", select: "Georgia"}, { value:"GU", select: "Guam"}, { value:"HI", select: "Hawaii"}, { value:"ID", select: "Idaho"}, { value:"IL", select: "Illinois"}, { value:"IN", select: "Indiana"}, { value:"IA", select: "Iowa"}, { value:"KS", select: "Kansas"}, { value:"KY", select: "Kentucky"}, { value:"LA", select: "Louisiana"}, { value:"ME", select: "Maine"}, { value:"MH", select: "Marshall Islands"}, { value:"MD", select: "Maryland"}, { value:"MA", select: "Massachusetts"}, { value:"MI", select: "Michigan"}, { value:"MN", select: "Minnesota"}, { value:"MS", select: "Mississippi"}, { value:"MO", select: "Missouri"}, { value:"MT", select: "Montana"}, { value:"NE", select: "Nebraska"}, { value:"NV", select: "Nevada"}, { value:"NH", select: "New Hampshire"}, { value:"NJ", select: "New Jersey"}, { value:"NM", select: "New Mexico"}, { value:"NY", select: "New York"}, { value:"NC", select: "North Carolina"}, { value:"ND", select: "North Dakota"}, { value:"MP", select: "Northern Mariana Islands"}, { value:"OH", select: "Ohio"}, { value:"OK", select: "Oklahoma"}, { value:"OR", select: "Oregon"}, { value:"PW", select: "Palau"}, { value:"PA", select: "Pennsylvania"}, { value:"PR", select: "Puerto Rico"}, { value:"RI", select: "Rhode Island"}, { value:"SC", select: "South Carolina"}, { value:"SD", select: "South Dakota"}, { value:"TN", select: "Tennessee"}, { value:"TX", select: "Texas"}, { value:"UT", select: "Utah"}, { value:"VT", select: "Vermont"}, { value:"VI", select: "Virgin Islands"}, { value:"VA", select: "Virginia"}, { value:"WA", select: "Washington"}, { value:"WV", select: "West Virginia"}, { value:"WI", select: "Wisconsin"}, { value:"WY", select: "Wyoming"}
    ];    

    const [visibleContinueButton, setVisibleContinueButton] = useState( false );

    const handleChange = ( prop ) => (event) => {
        console.log(event.target.value );
        let selectedValue ; 
        
        selectedValue = event.target.value ;
        
        setShippingDetails( {
            ...shippingDetails, 
            [prop]: selectedValue
        }); 
        dispatch( setRequesterInfo( {
            ...rInfo, 
            [prop]: selectedValue
        }) );

        console.log( shippingDetails );
    };


    return (
        <div className="Delivery">
            <Grid container spacing={2}>

                <Grid item xs={12} md={12}>
                    <div className='FormDetailsContainer'>
                        <div className='FormDetailsContainerHdr'>
                            <div className='FormDetailsContainerDtl'>
                                {/* <h3>Home delivery</h3> */}
                                {/* <h2>{shippingDetails.firstName}</h2>
                                <p>{shippingDetails.streetAddress}</p>
                                <p> {shippingDetails.floorNumber} </p>
                                <p>{shippingDetails.city}, {shippingDetails.state} {shippingDetails.postalCode}</p> */}
                            </div>
                            {/* <div className='AtdRightCol'>
                                <Button href="#text-buttons" className='atnEdit'>
                                    Edit
                                </Button>
                                <Button href="#text-buttons" className='atnDelete'>
                                    Delete
                                </Button>
                            </div> */}
                        </div>

                    </div>
                </Grid>

                {/* <Grid item md={6} xs={12}>
                    <PackageCard
                        cardFunction={cardFunction}
                        header={"I'd like it delivered"}
                        color="#1B2121"
                        icon={<LocalShippingIcon />}
                        Link={false}
                        cardIconStatus={true}
                    />
                </Grid>

                <Grid item md={6} xs={12}>
                    <PackageCard
                        cardFunction={cardFunction}
                        header={"I'll pick it up"}
                        color="#1B2121"
                        icon={<StorefrontRoundedIcon />}
                        Link={false}
                        cardIconStatus={true}
                    />
                </Grid> */}

                <Grid item md={6} xs={12}>
                    <TextInputFixedLabel
                        label="First name"
                        labelStatus={true}
                        value={shippingDetails?.shipppingFirstName || ''}                        
                        Errormessage="Please provide first name"
                        errortextStatus={errorFlag.firstName}                        
                        onChange={handleChange('shipppingFirstName')}
                        error={errorFlag.firstName}
                    />
                </Grid>

                <Grid item md={6} xs={12}>
                    <TextInputFixedLabel
                        label="Last name"
                        labelStatus={true}
                        helpertext="Helper text"
                        value={shippingDetails?.shippingLastName || ''}
                        Errormessage="Please provide last name"
                        errortextStatus={errorFlag.lastName}
                        count={false}
                        countStatus={false}
                        tooltipStatus={false}
                        onChange={handleChange('shippingLastName')}
                        error={errorFlag.lastName}
                    />
                </Grid>

                <Grid item md={6} xs={12}>
                    <TextInputFixedLabel
                        label="Resident street address"
                        labelStatus={true}
                        value={shippingDetails?.shippingStreetAddress || ''}
                        HelpertextStatus={true}
                        Errormessage="Please provide street address"
                        errortextStatus={errorFlag.streetAddress}
                        count={false}
                        countStatus={false}
                        tooltipStatus={false}
                        onChange={handleChange('shippingStreetAddress')}
                        error={errorFlag.streetAddress}
                    />
                </Grid>

                <Grid item md={6} xs={12}>
                    <TextInputFixedLabel
                        label="Floor Number (Optional)"
                        labelStatus={true}
                        helpertext="Helper text"
                        value={shippingDetails?.shippingFloorNumber || ''}
                        Errormessage="Error message"
                        errortextStatus={false}
                        count={false}
                        countStatus={false}
                        tooltipStatus={false}
                        onChange={handleChange('shippingFloorNumber')}
                    />
                </Grid>

                <Grid item md={4} xs={12}>
                    <TextInputFixedLabel
                        label="City/Town"
                        labelStatus={true}
                        value={shippingDetails?.shippingCity || ''}
                        HelpertextStatus={false}
                        Errormessage="Please provide city"
                        errortextStatus={errorFlag.city}
                        count={false}
                        countStatus={false}
                        tooltipStatus={false}
                        onChange={handleChange('shippingCity')}
                        error={errorFlag.city}
                    />
                </Grid>

                <Grid item md={4} xs={12}>
                    <SelectFieldOne
                        label="State/Province"
                        selectdata={selectState}
                        defaultValue={shippingDetails?.shippingState || 'NY'}
                        handleChange={handleChange('shippingState')}
                        
                    />
                </Grid>

                <Grid item md={4} xs={12}>
                    <TextInputFixedLabel
                        label="Zip/Postal code"
                        labelStatus={true}
                        value={shippingDetails.shippingPostalCode || ''}
                        HelpertextStatus={false}
                        Errormessage="Please provide postal code"
                        errortextStatus={errorFlag.postalCode}
                        count={false}
                        countStatus={false}
                        tooltipStatus={false}
                        onChange={handleChange('shippingPostalCode')}
                        error={errorFlag.postalCode}
                    />
                </Grid>




                <Grid item md={6} xs={12}>
                    <PhoneInputField
                        labelFixed="Phone number"
                        phoneInputVariant={"materialui"} // default, materialui, underlineInput, underlineWithFlag
                        country={'us'}
                        value={shippingDetails.shippingPhone || ''}
                        countryCodeEditable={false}
                        onChange={(phone, country) =>{
                            setShippingDetails({
                                ...shippingDetails, 
                                ['shippingPhone']: phone 
                            });
                            dispatch( setRequesterInfo(
                                {
                                    ...rInfo, 
                                    ['shippingPhone']: phone 
                                }
                            ))
                        }}
                        onBlur={() => console.log("onBlur")}
                        onKeyDown={(e) => console.log("onKeyDown", e.target.value)}
                        variant="outlined"
                        onlyCountries={["us", "ca", "gb", "my"]}
                        containerStyle={{}}
                        buttonStyle={{}}
                        inputStyle={{
                            marginLeft: "0px",
                            height: "40px",
                            width: "100%",
                            fontFamily: "Roboto-Regular",
                            fontSize: "16px",
                        }}
                        containerClass={{}}
                        errorText={"Phone number is required"}
                        error={false}
                        errorStyles={{ marginBottom: "5px" }}
                        autoFormat={true}
                        disableDropdown={false}
                        disabled={false}
                        disableCountryCode={false}
                        enableSearch={false}
                        disableSearchIcon={false}
                        placeholder={""}
                        inputProps={{}}
                        specialLabel={'Primary Phone'}                        
                        LabelStatus={true}
                        helpertext="In case of any questions or updates"

                    />
                </Grid>

                <Grid item md={6} xs={12}>
                    <TextInputFixedLabel
                        label="Email (Optional)"
                        labelStatus={true}
                        helpertext="We’ll email you a receipt and order updates"
                        HelpertextStatus={true}
                        Errormessage="Error message"
                        errortextStatus={false}
                        count={false}
                        countStatus={false}
                        tooltipStatus={false}
                        value={shippingDetails.shippingEmail || ''}
                        onChange={handleChange('shippingEmail')}
                    />
                </Grid>



                <Grid item md={12} xs={12}>
                    <div className='FormBtn'>
                        <ButtonOne
                            label="Continue"
                            buttoncolor="#56b149"
                            width="100%"
                            height="50px"
                            border="#ccc 0px solid"
                            borderRadius="4px"
                            color="#fff"
                            fontWeight="600"
                            textAlign="center"
                            disabled={visibleContinueButton}
                            onClick={continueClicked}
                        />
                    </div>

                </Grid>


            </Grid>





        </div>

    )
}

export default Delivery;